import DIApi from './_diApi';

class SalaryScaleAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'SalaryScales';
}

export default new SalaryScaleAPI();
